import { Injectable } from "@angular/core";
import { GenericResolver } from "./generic-resolver";
import { Observable, of } from "rxjs";
import { AppSessionService } from "../../../../shared/common/session/app-session.service";
import { Store } from "@ngrx/store";
import * as appReducer from '@app/reducer';
import { AddCorrelationIdInPageStateAction, ClearCorrelationIdsInPageStateAction } from "@app/actions";

@Injectable({
    providedIn: "root",
})
export class PageResolver extends GenericResolver {
    constructor(private store: Store<appReducer.State>) {
        super();
        
        const state: appReducer.State = appReducer.getState(this.store);
        this.store.select(s => s.root.pageState).subscribe((pageState) => {
            if(!pageState) return;
            this.PageCorrelationIds = pageState.correlationIds;
        })
    }

    public ReceivedCorrelationId: string;
    public PageCorrelationIds: string[];

    protected resolveCondition(): boolean {
        return this.PageCorrelationIds.indexOf(this.ReceivedCorrelationId) !== -1;
    }

    public clearPageCorrelationIds() {        
        this.store.dispatch(new ClearCorrelationIdsInPageStateAction());
    }

    public addCorrelationId(correlationId: string) {
        this.store.dispatch(new AddCorrelationIdInPageStateAction(correlationId));
    }
}
